import React, { useEffect, useState } from 'react';
import './EqCreateGroupBoard.scss';
import { Row, Col, Input } from 'antd';
import EqCreateGroup from '../eqCreateGroup/EqCreateGroup';
import { IEqGroupDto } from '../../shared/interfaces/IEqGroup';
import EqGroupAdd from '../eqGroupCreateOrEdit/EqGroupCreateOrEdit';
import { useTranslation, Trans } from 'react-i18next';

const EqGroupsBoard = (props: any) => {
    const { t, i18n } = useTranslation();

    const cancelFunction = (e: any) => {
       
    }

    const sendFunction = (data: any) => {
       
    }

    const [group, setGroup] = React.useState(props?.location?.state?.group as IEqGroupDto);

    const createGroupProps = {
        header: "Create Group", groupHeading: "Please select type of group", nameHeading: "Group Name", messageHeading: "Message", colorAssign: t("groupColor"),
        cancelFunc: cancelFunction, sendFunc: sendFunction, groupData: group
    };
    useEffect(() => {
        if (props?.location?.state != undefined) {
            setGroup(props?.location?.state?.group as IEqGroupDto);
        }
    }, []);
    return (
        <>
            <div className="eq-gb-container">
                <Row className="eq-gb-heading-row" align="bottom">
                    <Col className="eq-gb-col" flex="auto" sm={5} xs={4}>
                        <h3 className="eq-gb-heading">{t("groups")}</h3>
                    </Col>
                </Row>
                <div>
                        <EqCreateGroup {...createGroupProps}></EqCreateGroup>
                        {/* <EqGroupAdd {...createGroupProps}></EqGroupAdd> */}

                </div>
            </div>
        </>
    );
}

export default EqGroupsBoard;